<template>
    <Layout>
        <h1 v-bind:class="$style.title">
            500 Server Error
        </h1>
    </Layout>
</template>

<script>
    import Layout from '@layouts/main';

    export default {
        /**
         * Custom page meta data property for the view components.
         *
         * @type {Object}
         */
        metaInfo: {
            title: '500',
            meta: [
                {
                    name: 'description',
                    content: '500 - Server Error',
                },
            ],
        },

        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            Layout,
        },
    };
</script>

<style lang="scss" module>
    .title {
        @apply text-center;
    }
</style>
